var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3531 4.51094C13.4469 4.60469 13.5 4.73125 13.5 4.86406V14.5C13.5 14.7766 13.2766 15 13 15H3C2.72344 15 2.5 14.7766 2.5 14.5V1.5C2.5 1.22344 2.72344 1 3 1H9.63594C9.76875 1 9.89688 1.05313 9.99063 1.14688L13.3531 4.51094ZM12.3469 5.09375L9.40625 2.15313V5.09375H12.3469Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.34d20bf5c850ae3d2691db34a9dc1ec0.svg";
export { ForwardRef as ReactComponent };